import {May, Maybe} from '@coolcolduk/typescript-util';
import {castArray} from '@coolcolduk/util';
import {UserPermission} from '@cp/model';
import {AdminTab} from './adminTabs';

/**
 * Check if user has the required permission for a tab
 */
function hasPermission(
  userRoles: May<Maybe<string[]>>,
  requiredPermission?: UserPermission | UserPermission[],
): boolean {
  const permissionArray = requiredPermission ? castArray(requiredPermission) : [];
  // no required permission means no permission required
  if (permissionArray.length === 0) {
    return true;
  }

  if (!userRoles || userRoles.length === 0) {
    return false;
  }

  // Check if user has any of the required permissions
  return permissionArray.some((permission) => userRoles.includes(permission));
}

/**
 * Filter tabs based on user roles
 * @param tabs - Array of admin tabs
 * @param userRoles - User's roles array
 * @returns Filtered array of tabs that user has access to
 */
export function filterTabs(tabs: AdminTab[], userRoles: May<Maybe<string[]>>): AdminTab[] {
  return tabs.filter((tab) => hasPermission(userRoles, tab.permission));
}

/**
 * Check if user has access to any admin pages
 * @param tabs - Array of admin tabs
 * @param userRoles - User's roles array
 * @returns true if user has access to at least one admin page
 */
export function hasAnyPageAccess(tabs: AdminTab[], userRoles: May<Maybe<string[]>>): boolean {
  return filterTabs(tabs, userRoles).length > 0;
}
